import { api } from "@/infrastructure/api";
import { all, call, put, takeLatest } from "redux-saga/effects";
import * as A from "./actions";
import * as T from "./types";
import { AxiosResponse } from "axios";
import { notification } from "antd";

export function* fetchTickers({ payload }: ReturnType<typeof A.fetchTickers.request>) {
  try {
    const { data }: AxiosResponse<T.Tickers[]> = yield call(
      api.get,
      `/search/ticker/${payload.region}/${payload.text}`
    );

    yield put(A.fetchTickers.success(data));
  } catch (e) {
    yield put(A.fetchTickers.failure());
  }
}

export function* fetchBacktestMeta() {
  try {
    const { data }: AxiosResponse<T.Meta> = yield call(api.get, `/backtest/meta`);

    yield put(A.fetchBacktestMeta.success(data));
  } catch (e) {
    yield put(A.fetchBacktestMeta.failure());
  }
}

export function* runBacktest({ payload }: ReturnType<typeof A.fetchBacktestResult.request>) {
  try {
    const { data }: AxiosResponse<T.Result> = yield call(api.post, `/backtest/${payload.taskId}`, payload.setup);

    notification.success({
      message: "Backtest completed!"
    });
    yield put(A.fetchBacktestResult.success(data));
  } catch (e) {
    yield put(A.fetchBacktestResult.failure());
  }
}

export default function*() {
  yield all([
    takeLatest(A.fetchTickers.request, fetchTickers),
    takeLatest(A.fetchBacktestMeta.request, fetchBacktestMeta),
    takeLatest(A.fetchBacktestResult.request, runBacktest)
  ]);
}
